import VariableMutation from "../../../../../lib/html5-software-library/src/ranj/eng/content/VariableMutation";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTVariableManager from "../../../ngt/base/NGTVariableManager";
import PullContentManager from "../../../ngt/pull/PullContentManager";
import StoryConventions from "../../story-conventions/StoryConventions";
import MapCharacterInteractionEvent from "../event/MapCharacterInteractionEvent";
import MapCharacterDefinition from "../model/MapCharacterDefinition";
import MapLocationDefinition from "../model/MapLocationDefinition";

export default class MapCharacterInteractionCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {PullContentManager} pullContentManager 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(dispatcher, pullContentManager, variableManager) {
        super(dispatcher);

        this._pullContentManager = pullContentManager;
        this._variableManager = variableManager;
    }

    execute(evt) {
        const data = evt.params.data;
        /** @type {MapCharacterDefinition} */
        const character = data.character;

        switch (evt.type) {
            case MapCharacterInteractionEvent.CLICK:
                this.openPopup(SkinKeyRegistry.MAP_NODE_INFORMATION_POPUP_SKIN, null, {
                    needsOverlay: false,
                }, {
                    character,
                });
                return;
            case MapCharacterInteractionEvent.ENTER:
                const variableName = StoryConventions.nodeIdToVisitVariable(character.id);
                this._variableManager.setVariable(variableName, true, VariableMutation.SET);
                return;
        }

        console.warn(`[MapNodeInteractionCommand] Unhandled event type '${evt.type}'.`);
    }
}
